// AboutSection.js
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class AboutSection {
    constructor() {
        this.section = document.querySelector('[data-about]');

        if (!this.section) return;

        this.intro = this.section.querySelector('[data-about-intro]');
        this.stack = this.section.querySelector('[data-about-stack]');
        this.stackCategories = this.section.querySelectorAll('[data-stack-category]');
        this.techItems = this.section.querySelectorAll('[data-tech-item]');
        this.value = this.section.querySelector('[data-about-value]');
        this.valueItems = this.section.querySelectorAll('[data-value-item]');

        this.init();
    }

    init() {
        this.animateStack();
        this.animateValue();
        this.addHoverEffects();
    }


    /**
     * Animation de la stack technique
     */
    animateStack() {
        if (!this.stack) return;

        // Animation des catégories
        this.stackCategories.forEach((category, index) => {
            const categoryTitle = category.querySelector('.category-title');
            const items = category.querySelectorAll('.tech-item');

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: category,
                    start: 'top 85%',
                    end: 'top 60%',
                    scrub: true,
                    toggleActions: 'play none none reverse'
                }
            });

            timeline
                .from(categoryTitle, {
                    x: -30,
                    opacity: 0,
                    duration: 0.6,
                })
                .to(items, {
                    x: 0,
                    opacity: 1,
                    duration: 0.4,
                    stagger: 0.1,
                }, '-=0.3');
        });
    }

    /**
     * Animation de la valeur ajoutée
     */
    animateValue() {
        if (!this.value) return;

        this.valueItems.forEach((item, index) => {
            const number = item.querySelector('.value-number');
            const title = item.querySelector('.value-title');
            const text = item.querySelector('.value-text');

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: 'top 85%',
                    toggleActions: 'play none none reverse'
                }
            });

            timeline
                .from(number, {
                    scale: 0.5,
                    opacity: 0,
                    duration: 0.8,
                    ease: 'back.out(1.7)'
                })
                .from(title, {
                    y: 20,
                    opacity: 0,
                    duration: 0.6,
                    ease: 'power2.out'
                }, '-=0.4')
                .from(text, {
                    y: 15,
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.out'
                }, '-=0.3');
        });
    }

    /**
     * Effets au survol
     */
    addHoverEffects() {
        // Hover sur les tech items
        this.techItems.forEach(item => {
            const icon = item.querySelector('.tech-icon');
            const name = item.querySelector('.tech-name');

            item.addEventListener('mouseenter', () => {

                gsap.to(name, {
                    color: 'rgba(255, 255, 255, 1)',
                    duration: 0.3,
                    ease: 'power2.out'
                });
            });

            item.addEventListener('mouseleave', () => {
                gsap.to(icon, {
                    rotation: 0,
                    duration: 0.4,
                    ease: 'power2.out'
                });
                gsap.to(name, {
                    color: 'rgba(255, 255, 255, 0.7)',
                    duration: 0.3,
                    ease: 'power2.out'
                });
            });
        });

        // Hover sur les value items
        this.valueItems.forEach(item => {
            const number = item.querySelector('.value-number');

            item.addEventListener('mouseenter', () => {
                gsap.to(number, {
                    color: 'rgba(255, 255, 255, 0.15)',
                    scale: 1.05,
                    duration: 0.4,
                    ease: 'power2.out'
                });
            });

            item.addEventListener('mouseleave', () => {
                gsap.to(number, {
                    color: 'rgba(255, 255, 255, 0.05)',
                    scale: 1,
                    duration: 0.4,
                    ease: 'power2.out'
                });
            });
        });
    }

    /**
     * Destroy - nettoie les ScrollTriggers
     */
    destroy() {
        ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.vars.trigger && this.section.contains(trigger.vars.trigger)) {
                trigger.kill();
            }
        });
    }
}